import { Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ActionConfirmationConfig } from './action-confirmation-modal.config';
import { ActionConfirmationService } from './action-confirmation-modal.service';
import { GtwSnackbarService } from '../../_services/gtw-snackbar.service';

@Component({
    selector: 'gtw-action-confirmation-modal',
    templateUrl: './action-confirmation-modal.component.html',
    styleUrls: ['./action-confirmation-modal.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ActionConfirmationModalComponent implements OnDestroy {
  
  @Input() config!: ActionConfirmationConfig;
  
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  
  loading = false;
  minimise = false;
  private destroy$ = new Subject<void>();
  
  constructor(
    private actionService: ActionConfirmationService,
    private snackbar: GtwSnackbarService
  ) {}
  
  onConfirmAction() {
    if (!this.config) {
      this.snackbar.openSnackBar('Missing configuration', 'gtw-snackbar--red');
      return;
    }
    
    this.loading = true;
    
    this.actionService.executeAction(this.config)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.loading = false;
          
          const isSuccess = this.checkSuccess(response);
          const errorMsg = this.extractErrorMessage(response);
          
          if (isSuccess && !errorMsg) {
            this.snackbar.openSnackBar(this.config.successMessage, 'gtw-snackbar--green');
            this.confirmed.emit();
          } else {
            const fullError = `${this.config.errorMessagePrefix || 'Error'}${errorMsg ? '. ' + errorMsg : ''}`;
            this.snackbar.openSnackBar(fullError, 'gtw-snackbar--red');
          }
        },
        (error: any) => {
          this.loading = false;
          const errorMsg = error?.error?.errorMessage || 'Unknown error';
          this.snackbar.openSnackBar(`${this.config.errorMessagePrefix || 'Error'}. ${errorMsg}`, 'gtw-snackbar--red');
        }
      );
  }
  
  onCancel() {
    this.cancelled.emit();
  }
  
  onClose() {
    this.closed.emit();
  }
  
  private checkSuccess(response: any): boolean {
    if (this.config.responseFormat === 'callSuccess') {
      return response.callSuccess === "1";
    } else {
      return !response.data?.errorMessage || response.data.errorMessage === "null";
    }
  }
  
  private extractErrorMessage(response: any): string | null {
    if (this.config.responseFormat === 'callSuccess') {
      return response.errorMessage && response.errorMessage !== 'null' ? response.errorMessage : null;
    } else {
      return response.data?.errorMessage && response.data.errorMessage !== "null" ? response.data.errorMessage : null;
    }
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

